export type { SearchInputProps } from './SearchInput.types';
export { default } from './SearchInput';
